import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, type LazyComponent } from 'owa-bundling';
import { type CopilotDabProps } from './components/CopilotDab.Props';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotDab" */ './lazyIndex'),
    { name: 'CopilotDab' }
);

// TODO: add placeholder?
export const LazyCopilotDab: LazyComponent<CopilotDabProps, undefined, null> = createLazyComponent(
    lazyModule,
    m => m.CopilotDab
);

export { MAIN_BUTTON_ID } from './constants/mainButtonId';
